export default "__VITE_PUBLIC_ASSET__68fe21cb__"